
<style scoped lang="scss">
  // @import '~@/assets/styles/vars';
  $size: 145px;

  .scope {
    position: relative;
    width: $size;
    height: $size;
    border: 2px solid white;

    .no-image-label {
      display: block;
      opacity: 0.2;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      height: 10px;
    }
    .labels {
      // position: absolute;
      // bottom: 1px;
    }
    .topic {
      position: absolute;
      top: 4px;
      text-align: center;
      font-size: .9rem;
      width: 100%;
      padding: 2px
    }
    .subtopic {
      position: absolute;
      bottom: 4px;
      text-align: center;
      font-size: .5rem;
      padding: 2px;
      width: 100%;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
</style>

<template>
  <div class="t-moon--grad scope" @click="onClick" >
    <img v-if="imgSrc" :src="imgSrc" />
    <div v-else>
      <span class="no-image-label">NO IMAGE</span>
      <div class="labels">
        <h3 class="topic">{{projectData.musicName}}</h3>
        <h4 class="subtopic">{{projectData.artistName}}</h4>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * ジャケット画像
 * 画像ソースを渡された場合は画像を、
 * そうでない場合はprojectSrcをAjaxで拾って動的にそれっぽくする
 *
 */
import 'whatwg-fetch';

export default {
  name: 'musicJacket',
  props: {
    imgSrc: String,
    projectSrc: String,
  },
  data () {
    return {
      projectData: {
        musicName: "",
        artistName: "",
      },
    }
  },
  // computed: {
  //   projectData() {
  //     return this.fetchDetail(this.projectSrc);
  //   }
  // },

  methods: {
    fetchDetail: function(projectPath) {
      const self = this;

      fetch(projectPath)
      .then(function(response) {
        return response.json();
      })
      .then(function(json) {
        // console.log("fetch", this, json)
        self.projectData = json;
        return json;
      })
      .catch(error => {
        console.error(error);
      })
      ;
    },

    onClick: function(e) {
      this.$emit('click', e);
    },
  },

  created() {
    if (!this.imgSrc) {
      // ジャケ画像がない場合
      this.fetchDetail(this.projectSrc);
    }
  },

  mounted() { },
}
</script>



// WEBPACK FOOTER //
// src/components/sub/musicJacket.vue